import { Component } from '@angular/core';

@Component({
  selector: 'app-seo-off-page-dashboard',
  templateUrl: './seo-off-page-dashboard.component.html',
  styleUrls: ['./seo-off-page-dashboard.component.css'],
})
export class SeoOffPageDashboardComponent {
  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/marketing',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/marketing/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/marketing/social/strategy',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'GEO',
      route: '',
    },
    
  ];
}
